import { ListItem, styled } from "@mui/material";

export const PercentageRow = styled(ListItem)`
  display: grid;
  grid-template-columns: 30px 1fr 1fr 30px;
  align-items: center;
  min-height: 60px;
  padding: 8px 16px;
  gap: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.background.paper};
  .MuiTypography-root {
    font-size: 13px;
  }
  .total-cell {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #198653;
    font-weight: 500;
    .MuiSvgIcon-root {
      font-size: 14px;
      transform: translateY(-1px);
    }
  }
  .total-cell--error {
    color: ${({ theme }) => theme.palette.error.main};
  }
  .MuiFormControl-root {
    width: 90px;
    margin: 0;
    .MuiInputAdornment-root {
      margin-right: 8px;
    }
    .MuiInputBase-root {
      margin: 0;
      padding-right: 0;
    }
  }
  .label {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .pill-container {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    margin-left: ${({ theme }) => theme.spacing(1)};
    font-size: 12px;
    color: #198653;
    font-weight: 500;
    .MuiSvgIcon-root {
      font-size: 13px;
      transform: translateY(-1px);
    }
  }
  .pill-container--error {
    color: ${({ theme }) => theme.palette.error.main};
    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }
`;
